const employerPOCView = (data) => {
    let formData = data && data.getPOCById && data.getPOCById.POCFormData
    if(formData){
        let view = {
            name: formData.poc_emp_profile_name,
            sections: [
                {
                    name: 'Point of Contact - Name & Title',
                    fields: [
                        {
                            number: 1,
                            label: 'Last Name',
                            value: formData.poc_emp_last_name,

                        },
                        {
                            number: 2,
                            label: 'First Name',
                            value: formData.poc_emp_first_name,
                        },
                        {
                            number: 3,
                            label: 'Middle Name',
                            value: formData.poc_emp_middle_name,
                        },
                        {
                            number: 4,
                            label: 'Job Title',
                            value: formData.poc_emp_job_title
                        }
                    ]
                },
                {
                    name: 'Address',
                    fields: [
                        {
                            number: 5,
                            label: 'Address 1',
                            value: formData.poc_emp_address1,
                            
                        },
                        {
                            number: 6,
                            label: 'Address 2',
                            value: formData.poc_emp_address2,
                        },
                        {
                            number: 7,
                            label: 'City',
                            value: formData.poc_emp_city,
                            
                        },
                        {
                            number: 8,
                            label: 'State',
                            value: formData.poc_emp_state_id,
                            
                        },
                        {
                            number: 9,
                            label: 'Postal Code',
                            value: formData.poc_emp_zip,
                            
                        },
                        {
                            number: 10,
                            label: 'Country',
                            value: formData.poc_emp_country_id,
                            
                        },
                        {
                            number: 11,
                            label: 'Province (if applicable)',
                            value: formData.poc_emp_province,
                            
                        },
                    ]
                },
                {
                    name: 'Contact information',
                    fields: [
                        {
                            number: 12,
                            label: 'Telephone Number',
                            value: formData.poc_emp_phone,
                            
                        },
                        {
                            number: 13,
                            label: 'Extension',
                            value: formData.poc_emp_phone_ext,
                            
                        },
                        {
                            number: 14,
                            label: 'Email',
                            value: formData.poc_emp_email,
                            
                        },
                    ]
                },
            ]
        }
        return view;
    }
}

export default employerPOCView